import { Colors } from '@back-office/core';
import Avatar, { AvatarProps } from '@material-ui/core/Avatar';
import React from 'react';
import styled from 'styled-components';

export enum TransactionRecurringStatus {
  pending = 'pending',
  processing = 'processing',
  success = 'success',
  drop_off = 'drop_off',
  failed = 'failed',
}

interface GcpRecurringStatusProps extends AvatarProps {
  size?: number;
  status?: TransactionRecurringStatus;
}

function chooseStatusColor(status: TransactionRecurringStatus): keyof Colors {
  switch (status) {
    case TransactionRecurringStatus.success:
      return 'eucalyptus';
    case TransactionRecurringStatus.drop_off:
    case TransactionRecurringStatus.failed:
      return 'redOrange';
    case TransactionRecurringStatus.pending:
      return 'silver';
    case TransactionRecurringStatus.processing:
      return 'goldenrod';
    default:
      return 'silver';
  }
}

const getSize = (size: number): string => {
  if (size) {
    return `${size}px`;
  }
  return '1rem';
};

export const GcpTransactionRecurringStatus = styled(
  ({ size, status, ...rest }: GcpRecurringStatusProps) => (
    <Avatar {...rest}>&nbsp;</Avatar>
  )
)<GcpRecurringStatusProps>`
  ${(props): string =>
    props?.status &&
    `background-color: ${
      props.theme.palette?.common[chooseStatusColor(props.status)]
    }`};
  height: ${(props) => getSize(props.size)}};
  width: ${(props) => getSize(props.size)}};
`;

export default GcpTransactionRecurringStatus;
